import React from 'react';
import ReactDOMClient from 'react-dom/client';
import { Theme } from '@radix-ui/themes';
import '@radix-ui/themes/styles.css';
import './styles.css';
import './redesign.css';

import App from './App';

ReactDOMClient.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <Theme>
            <App />
        </Theme>
    </React.StrictMode>
);